import { Delete } from "@mui/icons-material"
import { Box, Button, Grid, IconButton, InputAdornment, List, ListItem, ListItemText, ListSubheader, MenuItem, Stack, TextField, Typography } from "@mui/material"
import React from "react"
import { StudioCancelConf } from "../../Objects/StudioCancelConf"

export interface StudioCancelConfListProps {
    studioCancelConfList: StudioCancelConf[]
    onDelete?: (studioCancelConf: StudioCancelConf) => void
    onCreate?: (studioCancelConf: StudioCancelConf) => void
}

const unit_name = {
    "HOUR": "時間前",
    "WORK": "営業日前",
    "DAY": "日前",
}

const StudioCancelConfList: React.FC<StudioCancelConfListProps> = ({
    studioCancelConfList,
    onDelete,
    onCreate,
}) => {

    const onSubmit = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const formData = new FormData(e.currentTarget)
        const studioCancelConf: StudioCancelConf = {}
        studioCancelConf.ccfg_start = parseInt(formData.get("ccfg_start")?.toString() ?? "");
        studioCancelConf.ccfg_end = parseInt(formData.get("ccfg_end")?.toString() ?? "");
        const ccfg_unit = formData.get("ccfg_unit")?.toString() ?? ""
        studioCancelConf.ccfg_unit = Object.keys(unit_name).find(value => value === ccfg_unit) as "HOUR" | "WORK" | "DAY" | undefined;
        studioCancelConf.ccfg_raito = parseInt(formData.get("ccfg_raito")?.toString() ?? "");

        if (onCreate) {
            onCreate(studioCancelConf)
        }

    }, [onCreate])

    return (
        <Box>
            <List
                dense
                subheader={
                    <ListSubheader
                        disableGutters
                        sx={{
                            fontSize: 20,
                        }}
                    >スタジオキャンセル料</ListSubheader>
                }
            >
                {studioCancelConfList.map(studioCancelConf => {
                    if (!studioCancelConf.ccfg_unit) {
                        return <></>
                    }
                    return (
                        <ListItem key={studioCancelConf.ccfg_id}
                            secondaryAction={
                                onDelete &&
                                (
                                    <IconButton edge="end" aria-label="delete"
                                        onClick={() => {
                                            onDelete(studioCancelConf)
                                        }}
                                    >
                                        <Delete />
                                    </IconButton>
                                )
                            }
                        >
                            <ListItemText
                                sx={{
                                    width: "30%",
                                    textAlign: "right",
                                }}
                            >{`${studioCancelConf.ccfg_start}～${studioCancelConf.ccfg_end}`} {unit_name[studioCancelConf.ccfg_unit]}</ListItemText>
                            <ListItemText
                                sx={{
                                    width: "30%",
                                    textAlign: "center",
                                }}
                            >{`スタジオ代の ${studioCancelConf.ccfg_raito}%`}</ListItemText>
                        </ListItem>
                    )
                })}
            </List>
            <Box
                component={"form"}
                onSubmit={onSubmit}
            >
                <Grid container
                    spacing={1}
                    maxWidth={400}
                    mx={"auto"}
                >
                    <Grid item xs={12} md={12}>
                        <Stack
                            direction={"row"}
                            alignItems={"center"}
                            spacing={1}
                        >
                            <TextField
                                name="ccfg_start"
                                size="small"
                                sx={{
                                    width: "30%"
                                }}
                            />
                            <Typography>～</Typography>
                            <TextField
                                name="ccfg_end"
                                size="small"
                                sx={{
                                    width: "30%"
                                }}
                            />
                            <TextField
                                name="ccfg_unit"
                                size="small"
                                sx={{
                                    width: "40%"
                                }}
                                select
                                defaultValue={"HOUR"}
                            >
                                {Object.entries(unit_name).map(value => {
                                    return <MenuItem value={value[0]} key={value[0]}>{value[1]}</MenuItem>
                                })}
                            </TextField>
                        </Stack>
                    </Grid>
                    <Grid item xs={10} md={8}>
                        <TextField
                            name="ccfg_raito"
                            size="small"
                            fullWidth
                            InputProps={{
                                startAdornment: <InputAdornment position="start">スタジオ代の</InputAdornment>,
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                        />
                    </Grid>
                    <Grid item xs={2} md={4}>
                        <Button
                            variant="outlined"
                            type="submit"
                            fullWidth
                        >登録</Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default StudioCancelConfList